import { getConfigXMLName, link_out } from '../../utils/DictionaryManagementUtils';
import { getPathName } from '../Utils/GeneralUtills';

export const kbdAuthSteps = () => {
  const authSteps = [];

  // ----- "stepAuthCredentials" screen -----
  {
    const stepAuthCredentials = {
      name: 'stepAuthCredentials',
      screen: 'authCredentials',
      actionPath: 'authCredentialsPath',
    };
    authSteps.push(stepAuthCredentials);
  }

  // ----- "stepAuthPinCode" screen -----
  {
    const stepAuthPinCode = {
      name: 'stepAuthPinCode',
      screen: 'authPinCode',
      actionPath: 'authPinCodePath',
    };
    authSteps.push(stepAuthPinCode);
  }

  // ----- "stepAuthOtp" screen -----
  {
    const stepAuthOtp = {
      name: 'stepAuthOtp',
      screen: 'authOtp',
      actionPath: 'authOtpPath',
    };
    authSteps.push(stepAuthOtp);
  }

  // ----- "stepAuthBiometric" screen -----
  {
    const stepAuthBiometric = {
      name: 'stepAuthBiometric',
      screen: 'authBiometric',
      actionPath: 'authBiometricPath',
    };
    authSteps.push(stepAuthBiometric);
  }
  // ----- "stepAuthPassword" screen -----

  const stepAuthPassword = {
    name: 'stepAuthPassword',
    screen: 'authPassword',
    actionPath: 'authPasswordPath',
  };
  authSteps.push(stepAuthPassword);

  return authSteps;
};

// ======================= errorSteps: ==========================

export const kbdErrorSteps = () => {
  const errorSteps = [];

  // ----- "stepLandscapeError" screen -----
  {
    const stepLandscapeError = {
      name: 'stepLandscapeError',
      screen: 'landscapeError',
      actionPath: 'landscapeErrorPath',
    };
    errorSteps.push(stepLandscapeError);
  }

  // ----- "stepGeneralError" screen -----
  {
    const stepGeneralError = {
      name: 'stepGeneralError',
      screen: 'generalError',
      actionPath: 'generalErrorPath',
    };
    errorSteps.push(stepGeneralError);
  }

  // ----- "stepTransactionError" screen -----
  {
    const stepTransactionError = {
      name: 'stepTransactionError',
      screen: 'transactionError',
      actionPath: 'transactionErrorPath',
    };
    errorSteps.push(stepTransactionError);
  }

  // ----- "stepConnectionError" screen -----
  {
    const stepConnectionError = {
      name: 'stepConnectionError',
      screen: 'connectionError',
      actionPath: 'connectionErrorPath',
    };
    errorSteps.push(stepConnectionError);
  }

  return errorSteps;
};

export const kbdStepMenu = ({ services, launch }) => {
  const { auth_upon_tapping_the_bank_icon } = launch.auth;
  const { layout_menu_screen } = services.menu;
  const stepMenu = {
    name: 'stepMenu',
    screen: 'menu',
    isFullScreen: layout_menu_screen,
    isAuthNeeded: auth_upon_tapping_the_bank_icon,
    steps: [],
  };

  services.screens_ordering.forEach((serviceKey) => {
    const service = services[serviceKey];
    if (service.selected && (service.sub_category !== link_out)) {
      stepMenu.steps.push({
        actionPath: getPathName(service.sub_category, service.duplication_number),
        flowConfiguration: getConfigXMLName(serviceKey),
      });
    }
  });

  return [stepMenu];
};
